import React, {useMemo, useState} from 'react'
import "./SafetyInfractionsChart.css"
import { BarChart } from '@mui/x-charts/BarChart';
import { FilterType } from "./WorkerAnalyticsChart";
import {
    handleXAxisData,
    handleYAxisData,
} from "../../util/chartUtil";


function SafetyInfractionsChart({filterType, workerName}) {
    const [safetyInfractionFilter, setSafetyInfractionFilter] = useState(filterType === 'last_seven_days' ? FilterType.WEEK.toString() : FilterType.DAY.toString());


    const handleXAxisDataBucketDay =  useMemo(() => handleYAxisData(FilterType.DAY.toString()), []);
    const handleXAxisDataBucketWeek =  useMemo(() => handleYAxisData(FilterType.WEEK.toString()), []);
    const handleXAxisDataBucketMonth =  useMemo(() => handleYAxisData(FilterType.MONTH.toString()), []);
    const handleXAxisDataBucketYear =  useMemo(() => handleYAxisData(FilterType.YEAR.toString()), []);


    const [, setSafetyInfractionData] = useState(handleYAxisData(FilterType.WEEK.toString()));

    const [securityInfractionFilter, setSecurityInfractionFilter] = useState(filterType === 'last_seven_days' ? FilterType.WEEK.toString() : FilterType.DAY.toString());

    const handleXAxisDataBucketSIDay =  useMemo(() => handleYAxisData(FilterType.DAY.toString()), []);
    const handleXAxisDataBucketSIWeek =  useMemo(() => handleYAxisData(FilterType.WEEK.toString()), []);
    const handleXAxisDataBucketSIMonth =  useMemo(() => handleYAxisData(FilterType.MONTH.toString()), []);
    const handleXAxisDataBucketSIYear =  useMemo(() => handleYAxisData(FilterType.YEAR.toString()), []);

    const [, setSecurityInfractionData] = useState(handleYAxisData(FilterType.WEEK.toString()));
    const [hoursOfOperationFilter, setHoursOfOperationFilter] = useState(filterType === 'last_seven_days' ? FilterType.WEEK.toString() : FilterType.DAY.toString());


    const handleXAxisDataBucketHOODay =  useMemo(() => handleYAxisData(FilterType.DAY.toString()), []);
    const handleXAxisDataBucketHOOWeek =  useMemo(() => handleYAxisData(FilterType.WEEK.toString()), []);
    const handleXAxisDataBucketHOOMonth =  useMemo(() => handleYAxisData(FilterType.MONTH.toString()), []);
    const handleXAxisDataBucketHOOYear =  useMemo(() => handleYAxisData(FilterType.YEAR.toString()), []);



    const [, setHoursOfOperationData] = useState(handleYAxisData(FilterType.WEEK.toString()));

    const [productivityOperationFilter, setProductivityOperationFilter] = useState(filterType === 'last_seven_days' ? FilterType.WEEK.toString() : FilterType.DAY.toString());


    const handleXAxisDataBucketProDay =  useMemo(() => handleYAxisData(FilterType.DAY.toString()), []);
    const handleXAxisDataBucketProWeek =  useMemo(() => handleYAxisData(FilterType.WEEK.toString()), []);
    const handleXAxisDataBucketProMonth =  useMemo(() => handleYAxisData(FilterType.MONTH.toString()), []);
    const handleXAxisDataBucketProYear =  useMemo(() => handleYAxisData(FilterType.YEAR.toString()), []);



    const [, setProductivityOperationData] = useState(handleYAxisData(FilterType.WEEK.toString()));

    const [missingSafetyShoesFilter, setMissingSafetyShoesFilter] = useState(filterType === 'last_seven_days' ? FilterType.WEEK.toString() : FilterType.DAY.toString());

    const handleXAxisDataBucketSSDay =  useMemo(() => handleYAxisData(FilterType.DAY.toString()), []);
    const handleXAxisDataBucketSSWeek =  useMemo(() => handleYAxisData(FilterType.WEEK.toString()), []);
    const handleXAxisDataBucketSSMonth =  useMemo(() => handleYAxisData(FilterType.MONTH.toString()), []);
    const handleXAxisDataBucketSSYear =  useMemo(() => handleYAxisData(FilterType.YEAR.toString()), []);

    const [, setMissingSafetyShoesData] = useState(handleYAxisData(FilterType.WEEK.toString()));


    return (
        <div className='chart-container'>
            <div className="chart-section-1">
                <div className="chart-1">
                    <div className="analytics-filter">
                        <p className='chart-heading'>Missing Helmet</p>
                        <div className="filter-sec">
                            <select onChange={(e) => {
                                setSafetyInfractionFilter(e.target.value)
                                setSafetyInfractionData(handleYAxisData(e.target.value.toString()))
                            }}
                                    defaultValue={safetyInfractionFilter}>
                                <option value={FilterType.DAY.toString()}
                                        selected={safetyInfractionFilter === FilterType.DAY.toString()}>{FilterType.DAY.toString()}</option>
                                <option value={FilterType.WEEK.toString()}
                                        selected={safetyInfractionFilter === FilterType.WEEK.toString()}>{FilterType.WEEK.toString()}</option>
                                <option value={FilterType.MONTH.toString()}
                                        selected={safetyInfractionFilter === FilterType.MONTH.toString()}>{FilterType.MONTH.toString()}</option>
                                <option value={FilterType.YEAR.toString()}
                                        selected={safetyInfractionFilter === FilterType.YEAR.toString()}>{FilterType.YEAR.toString()}</option>
                            </select>
                        </div>
                    </div>

                    <BarChart
                        xAxis={[{
                            scaleType: 'band',
                            data: handleXAxisData(safetyInfractionFilter)
                        }]}
                        series={[{data: safetyInfractionFilter === FilterType.DAY
                                ? handleXAxisDataBucketDay
                                : (safetyInfractionFilter === FilterType.WEEK
                                        ? handleXAxisDataBucketWeek
                                        : (safetyInfractionFilter === FilterType.MONTH
                                            ? handleXAxisDataBucketMonth : handleXAxisDataBucketYear)
                                ), color: '#d97575'}]}
                        width={400}
                        height={300}
                    />

                </div>
                <div className="chart-2">
                    <div className="analytics-filter">
                        <p className='chart-heading'>Missing Safety Vest </p>
                        <div className="filter-sec">
                            <select onChange={(e) => {
                                setHoursOfOperationFilter(e.target.value)
                                setHoursOfOperationData(handleYAxisData(e.target.value.toString()))
                            }}
                                    defaultValue={hoursOfOperationFilter}>
                                <option value={FilterType.DAY.toString()}
                                        selected={hoursOfOperationFilter === FilterType.DAY.toString()}>{FilterType.DAY.toString()}</option>
                                <option value={FilterType.WEEK.toString()}
                                        selected={hoursOfOperationFilter === FilterType.WEEK.toString()}>{FilterType.WEEK.toString()}</option>
                                <option value={FilterType.MONTH.toString()}
                                        selected={hoursOfOperationFilter === FilterType.MONTH.toString()}>{FilterType.MONTH.toString()}</option>
                                <option value={FilterType.YEAR.toString()}
                                        selected={hoursOfOperationFilter === FilterType.YEAR.toString()}>{FilterType.YEAR.toString()}</option>
                            </select>
                        </div>
                    </div>

                    <BarChart
                        xAxis={[{
                            scaleType: 'band',
                            data: handleXAxisData(hoursOfOperationFilter)
                        }]}
                        series={[{
                            data:  hoursOfOperationFilter === FilterType.DAY
                                ? handleXAxisDataBucketHOODay
                                : (hoursOfOperationFilter === FilterType.WEEK
                                        ? handleXAxisDataBucketHOOWeek
                                        : (hoursOfOperationFilter === FilterType.MONTH
                                            ? handleXAxisDataBucketHOOMonth : handleXAxisDataBucketHOOYear)
                                ),
                            color: '#9FEEA2'}]}
                        width={400}
                        height={300}
                    />

                </div>
                <div className="chart-3">
                    <div className="analytics-filter">
                        <p className='chart-heading'>Missing Safety Gloves </p>
                        <div className="filter-sec">
                            <select onChange={(e) => {
                                setSecurityInfractionFilter(e.target.value)
                                setSecurityInfractionData(handleYAxisData(e.target.value.toString()))
                            }}
                                    defaultValue={securityInfractionFilter}>
                                <option value={FilterType.DAY.toString()}
                                        selected={securityInfractionFilter === FilterType.DAY.toString()}>{FilterType.DAY.toString()}</option>
                                <option value={FilterType.WEEK.toString()}
                                        selected={securityInfractionFilter === FilterType.WEEK.toString()}>{FilterType.WEEK.toString()}</option>
                                <option value={FilterType.MONTH.toString()}
                                        selected={securityInfractionFilter === FilterType.MONTH.toString()}>{FilterType.MONTH.toString()}</option>
                                <option value={FilterType.YEAR.toString()}
                                        selected={securityInfractionFilter === FilterType.YEAR.toString()}>{FilterType.YEAR.toString()}</option>
                            </select>
                        </div>
                    </div>

                    <BarChart
                        xAxis={[{
                            scaleType: 'band',
                            data: handleXAxisData(securityInfractionFilter)
                        }]}
                        series={[{
                            data: securityInfractionFilter === FilterType.DAY.toString()
                                ? handleXAxisDataBucketSIDay
                                : (securityInfractionFilter === FilterType.WEEK.toString()
                                        ? handleXAxisDataBucketSIWeek
                                        : (securityInfractionFilter === FilterType.MONTH.toString()
                                            ? handleXAxisDataBucketSIMonth : handleXAxisDataBucketSIYear)
                                ),
                            color: '#D9975A'
                        }]}
                        width={400}
                        height={300}
                    />

                </div>
                <div className="chart-4">
                    <div className="analytics-filter">
                        <p className='chart-heading'>Missing Safety Goggles </p>
                        <div className="filter-sec">
                            <select onChange={(e) => {
                                setProductivityOperationFilter(e.target.value)
                                setProductivityOperationData(handleYAxisData(e.target.value.toString()))
                            }}
                                    defaultValue={productivityOperationFilter}>
                                <option value={FilterType.DAY.toString()}
                                        selected={productivityOperationFilter === FilterType.DAY.toString()}>{FilterType.DAY.toString()}</option>
                                <option value={FilterType.WEEK.toString()}
                                        selected={productivityOperationFilter === FilterType.WEEK.toString()}>{FilterType.WEEK.toString()}</option>
                                <option value={FilterType.MONTH.toString()}
                                        selected={productivityOperationFilter === FilterType.MONTH.toString()}>{FilterType.MONTH.toString()}</option>
                                <option value={FilterType.YEAR.toString()}
                                        selected={productivityOperationFilter === FilterType.YEAR.toString()}>{FilterType.YEAR.toString()}</option>
                            </select>
                        </div>
                    </div>
                    <BarChart
                        xAxis={[{
                            scaleType: 'band',
                            data: handleXAxisData(productivityOperationFilter)
                        }]}
                        series={[
                            {
                                data: productivityOperationFilter === FilterType.DAY
                                    ? handleXAxisDataBucketProDay
                                    : (productivityOperationFilter === FilterType.WEEK
                                            ? handleXAxisDataBucketProWeek
                                            : (productivityOperationFilter === FilterType.MONTH
                                                ? handleXAxisDataBucketProMonth : handleXAxisDataBucketProYear)
                                    ),
                                area: true, color: '#169AB9'
                            },
                        ]}
                        width={400}
                        height={300}
                    />
                </div>
                <div className="chart-5">
                    <div className="analytics-filter">
                        <p className='chart-heading'>Missing Safety Shoes </p>
                        <div className="filter-sec">
                            <select onChange={(e) => {
                                setMissingSafetyShoesFilter(e.target.value)
                                setMissingSafetyShoesData(handleYAxisData(e.target.value.toString()))
                            }}
                                    defaultValue={missingSafetyShoesFilter}>
                                <option value={FilterType.DAY.toString()}
                                        selected={missingSafetyShoesFilter === FilterType.DAY.toString()}>{FilterType.DAY.toString()}</option>
                                <option value={FilterType.WEEK.toString()}
                                        selected={missingSafetyShoesFilter === FilterType.WEEK.toString()}>{FilterType.WEEK.toString()}</option>
                                <option value={FilterType.MONTH.toString()}
                                        selected={missingSafetyShoesFilter === FilterType.MONTH.toString()}>{FilterType.MONTH.toString()}</option>
                                <option value={FilterType.YEAR.toString()}
                                        selected={missingSafetyShoesFilter === FilterType.YEAR.toString()}>{FilterType.YEAR.toString()}</option>
                            </select>
                        </div>
                    </div>

                    <BarChart
                        xAxis={[{
                            scaleType: 'band',
                            data: handleXAxisData(missingSafetyShoesFilter)
                        }]}
                        series={[
                            {
                                data: missingSafetyShoesFilter === FilterType.DAY
                                    ? handleXAxisDataBucketSSDay
                                    : (missingSafetyShoesFilter === FilterType.WEEK
                                            ? handleXAxisDataBucketSSWeek
                                            : (missingSafetyShoesFilter === FilterType.MONTH
                                                ? handleXAxisDataBucketSSMonth : handleXAxisDataBucketSSYear)
                                    ),
                                area: true, color: '#6e801f'
                            },
                        ]}
                        width={400}
                        height={300}
                    />

                </div>
            </div>

        </div>
    )
}

export default SafetyInfractionsChart
